<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('school.academic.operation.classOperation.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('school.academic.operation.classOperation.pageTitle'),
            href: '/class-operations'
          },
          { text: $t('create'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal">
            <h1 class="section-divider">
              {{ $t('school.academic.operation.classOperation.academicStudy') }}
            </h1>
            <div class="row mb-3">
              <div class="col-sm-12 col-lg-6 col-md-12">
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label">
                    {{
                      $t(
                        'school.academic.operation.classOperation.academicTerm'
                      )
                    }}
                    <span class="text-danger">*</span>
                  </label>
                  <div class="col-md-7">
                    <a-select
                      v-model.number="model.ac_term_id"
                      :options="termLists"
                      @change="getMainAndSub"
                    ></a-select>
                    <div class="validate" v-if="errors.has('ac_term_id')">
                      {{ errors.first('ac_term_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label">
                    {{
                      $t('school.academic.operation.classOperation.mainProgram')
                    }}
                    <i class="fa fa-spinner spin" v-if="filterSub"></i>
                  </label>
                  <div class="col-md-7">
                    <a-select
                      disabled
                      v-model="model.acp_id"
                      :options="mainProgram"
                    >
                    </a-select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label">
                    {{
                      $t('school.academic.operation.classOperation.subProgram')
                    }}
                    <i class="fa fa-spinner spin" v-if="filterSub"></i>
                  </label>
                  <div class="col-md-7">
                    <a-select
                      disabled
                      v-model="model.acps_id"
                      :options="subProgram"
                    >
                    </a-select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label">
                    {{ $t('school.academic.operation.classOperation.level') }}
                    <i class="fa fa-spinner spin" v-if="filterLevel"></i>
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.level_id"
                      :class="{ 'is-invalid': errors.has('level_id') }"
                    >
                      <option :value="null">{{ $t('select') }}</option>
                      <option
                        v-for="(level, index) in levelResource"
                        :key="index"
                        :value="level.level_id"
                      >
                        {{ level.level_name_foreign }}
                      </option>
                    </select>
                    <div class="invalid-feedback" v-if="errors.has('level_id')">
                      {{ errors.first('level_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('school.academic.operation.classOperation.grade') }}
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.grade_id"
                      :class="{ 'is-invalid': errors.has('grade_id') }"
                      @change="onGetSubject"
                    >
                      <option :value="null">{{ $t('select') }}</option>
                      <option
                        v-for="(grade, index) in grades"
                        :key="index"
                        :value="grade.grade_id"
                      >
                        {{ grade.grade_name_foreign }}
                      </option>
                    </select>
                    <div class="invalid-feedback" v-if="errors.has('grade_id')">
                      {{ errors.first('grade_id') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-lg-6 col-md-12">
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('school.academic.operation.classOperation.year') }}
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.academic_year"
                      :class="{ 'is-invalid': errors.has('academic_year') }"
                      ref="academic_year"
                      @change="onGetSubject"
                    >
                      <option
                        :value="null"
                        disabled
                        selected
                        style="display: none"
                      >
                        {{ $t('select') }}
                      </option>
                      <option
                        v-for="(year, index) in academic_years"
                        :value="year"
                        :key="index"
                      >
                        {{ year }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('academic_year')"
                    >
                      {{ errors.first('academic_year') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{
                      $t('school.academic.operation.classOperation.semester')
                    }}
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.academic_term"
                      :class="{ 'is-invalid': errors.has('academic_term') }"
                      @change="onGetSubject"
                    >
                      <option
                        :value="null"
                        disabled
                        selected
                        style="display: none"
                      >
                        {{ $t('select') }}
                      </option>
                      <option
                        v-for="(term, index) in academic_terms"
                        :value="term"
                        :key="index"
                      >
                        {{ term }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('academic_term')"
                    >
                      {{ errors.first('academic_term') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{
                      $t('school.academic.operation.classOperation.subjectName')
                    }}
                  </label>
                  <div class="col-md-7">
                    <ts-loading-banner :loading="fetchSubject">
                      <select
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('subject_id') }"
                        v-model="model.subject_id"
                        @change="onChangeSubject($event)"
                      >
                        <option :value="null">{{ $t('select') }}</option>
                        <option
                          v-for="(subject, index) in subjectResource"
                          :key="index"
                          :value="subject.subject_id"
                        >
                          {{
                            subject.subject_name_foreign +
                              ' | ' +
                              subject.subject_code
                          }}
                        </option>
                      </select>
                    </ts-loading-banner>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('subject_id')"
                    >
                      {{ errors.first('subject_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{
                      $t('school.academic.operation.classOperation.className')
                    }}
                  </label>
                  <div class="col-md-7">
                    <input
                      v-model.trim="model.class_name"
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('class_name') }"
                      ref="class_name"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('class_name')"
                    >
                      {{ errors.first('class_name') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label">
                    {{
                      $t('school.academic.operation.classOperation.description')
                    }}
                  </label>
                  <div class="col-md-7">
                    <textarea
                      v-model="model.class_desc"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('class_desc') }"
                      rows="1"
                    ></textarea>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('class_desc')"
                    >
                      {{ errors.first('class_desc') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    class="col-md-4 form-col-label control-label required"
                    >{{
                      $t('school.academic.operation.classOperation.weekdayType')
                    }}</label
                  >
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.weekday_type_id"
                      :class="{ 'is-invalid': errors.has('weekday_type_id') }"
                      @change="() => (model.ac_st_id = null)"
                    >
                      <option :value="null">{{ $t('select') }}</option>
                      <option
                        v-for="(weekday_type, index) in weekday_types"
                        :value="weekday_type.id"
                        :key="index"
                      >
                        {{ weekday_type.weekday_type }}
                        <span>{{
                          weekday_type.is_required_study_time
                            ? ' (Required study time: No)'
                            : ' (Required study time: Yes)'
                        }}</span>
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('weekday_type_id')"
                    >
                      {{ errors.first('weekday_type_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    class="col-md-4 form-col-label control-label"
                    :class="{ required: isRequiredStudyTime }"
                  >
                    {{
                      $t('school.academic.operation.classOperation.studyTime')
                    }}</label
                  >
                  <div class="col-md-7">
                    <a-select
                      v-model="model.ac_st_id"
                      :options="studyTimes"
                      :placeholder="$t('select')"
                      :class="{ 'is-invalid': errors.has('ac_st_id') }"
                    >
                    </a-select>
                    <div class="validate" v-if="errors.has('ac_st_id')">
                      {{ errors.first('ac_st_id') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h1 class="section-divider">
              {{ $t('school.academic.operation.classOperation.moreInfo') }}
            </h1>
            <div class="row mb-3">
              <div class="col-sm-12 col-lg-6 col-md-12">
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{
                      $t('school.academic.operation.classOperation.building')
                    }}
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.building_id"
                      :class="{ 'is-invalid': errors.has('building_id') }"
                    >
                      <option :value="null">{{ $t('select') }}</option>
                      <option
                        v-for="(b, index) in building"
                        :key="index"
                        :value="b.building_id"
                      >
                        {{ b.building_name }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('building_id')"
                    >
                      {{ errors.first('building_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('school.academic.operation.classOperation.room') }}
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('room_id') }"
                      v-model="model.room_id"
                    >
                      <option value>{{ $t('select') }}</option>
                      <option
                        v-for="(room, index) in getRooms"
                        :key="index"
                        :value="room.room_id"
                      >
                        {{ room.room_name }}
                      </option>
                    </select>
                    <div class="invalid-feedback" v-if="errors.has('room_id')">
                      {{ errors.first('room_id') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-lg-6 col-md-12">
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{
                      $t('school.academic.operation.classOperation.lecturer')
                    }}
                  </label>
                  <div class="col-md-7">
                    <a-select
                      v-model="model.teacher_id"
                      :options="teacherLists"
                    ></a-select>
                    <div class="validate" v-if="errors.has('teacher_id')">
                      {{ errors.first('teacher_id') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h1 class="section-divider">
              {{
                $t('school.academic.operation.classOperation.requiredThesis')
              }}
            </h1>
            <div class="row mb-3">
              <div class="col-sm-12 col-lg-6 col-md-12">
                <div class="form-group row">
                  <label class="col-md-4 col-form-label"></label>
                  <div class="col-md-7">
                    <ts-checkbox v-model="model.required_thesis">
                      {{
                        $t(
                          'school.academic.operation.classOperation.requiredThesis'
                        )
                      }}
                    </ts-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <h1 class="section-divider">
              {{
                $t('school.academic.operation.classOperation.subjectEnrollment')
              }}
            </h1>
            <div class="row mb-3">
              <div class="col-md-12">
                <ts-table
                  :columns="columns"
                  :records="students"
                  :showCheckbox="true"
                  @check-items="checkItem"
                >
                  <template v-slot="{ record }">
                    <td class="ts-whitespace-no-wrap">
                      {{ record.card_number ? record.card_number : null }}
                    </td>
                    <td class="ts-whitespace-no-wrap">
                      {{ record.full_name_en ? record.full_name_en : null }}
                    </td>
                  </template>
                </ts-table>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12 text-right">
                <ts-button
                  color="info"
                  outline
                  class="btn btn-default mr-2"
                  @click="$router.push({ name: 'class-operation' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button class="btn btn-primary" @click.prevent="onSave">{{
                  $t('save')
                }}</ts-button>
              </div>
            </div>
          </form>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'classOperationCopyClass',
  data() {
    return {
      loading: false,
      filterSub: false,
      filterLevel: false,
      fetchSubject: false,
      errors: new Errors(),
      subResource: [],
      levelResource: [],
      subjectResource: [],
      study_times: [],
      ac_terms: [],
      model: {
        acp_id: null,
        acps_id: null,
        level_id: null,
        ac_year_id: null,
        ac_term_id: null,
        grade_id: null,
        room_id: null,
        teacher_id: null,
        academic_year: null,
        academic_term: null,
        subject_id: null,
        class_name: '',
        class_desc: '',
        building_id: null,
        ac_st_id: null,
        study_time: null,
        weekday_type_id: null,
        required_thesis: false,
        student_id_list: []
      }
    }
  },
  async created() {
    await this.findClass()
    await this.fetchBeforeCreate()
  },
  computed: {
    ...mapState('classOperation', [
      'building',
      'categories',
      'academic_years',
      'academic_terms',
      'weekday_types',
      'editData'
    ]),
    columns() {
      return [
        {
          name: this.$t('studentEnrollment.cardNumber')
        },
        {
          name: this.$t('studentEnrollment.studentName')
        }
      ]
    },
    students() {
      if (this.editData.students) {
        return this.editData.students
      }

      return []
    },
    teacherLists() {
      return this.$store.state.classOperation.teacherList.map(el => ({
        value: el.teacher_id,
        label: el.fname_foreign + ' ' + el.lname_foreign
      }))
    },
    termLists() {
      return _.sortBy(this.ac_terms, ['ac_status_id']).map(el => ({
        value: el.ac_term_id,
        label:
          el.term_name +
          (el.ac_status_id == 1
            ? ' ( Current ) '
            : el.ac_status_id == 2
            ? ' ( History ) '
            : ' ( Next ) ')
      }))
    },
    subProgram: {
      get() {
        return this.subResource.map(el => ({
          value: el.acps_id,
          label: el.acps_name_foreign
        }))
      }
    },
    mainProgram: {
      get() {
        if (this.subResource.length > 0) {
          this.model.acp_id = this.subResource[0].main_program.acp_id
          return [
            {
              value: this.subResource[0].main_program.acp_id,
              label: this.subResource[0].main_program.acp_name_foreign
            }
          ]
        }

        return []
      }
    },
    grades() {
      if (this.levelResource.length > 0) {
        let level = this.levelResource.filter(
          l => l.level_id === this.model.level_id
        )
        if (level.length > 0) {
          return level[0].grades
        }
      }

      return []
    },
    getRooms() {
      if (this.building.length > 0) {
        let room = this.building.filter(
          r => r.building_id === this.model.building_id
        )
        if (room.length > 0) {
          return room[0].rooms
        }
      }

      return []
    },
    studyTimes() {
      if (this.model.weekday_type_id && this.study_times.length > 0) {
        return this.study_times
          .filter(s => s.weekday_type_id === this.model.weekday_type_id)
          .map(el => ({
            value: el.ac_st_id,
            label:
              el.study_time +
              ' | ' +
              el.session +
              (el.number_of_session
                ? ' | Session Order: ' +
                  moment(el.number_of_session, 'D').format('Do')
                : '')
          }))
      }

      return this.study_times.map(el => ({
        value: el.ac_st_id,
        label:
          el.study_time +
          ' | ' +
          el.session +
          (el.number_of_session
            ? ' | Session Order: ' +
              moment(el.number_of_session, 'D').format('Do')
            : '')
      }))
    },
    isRequiredStudyTime() {
      if (this.model.weekday_type_id && this.weekday_types.length > 0) {
        return !this.weekday_types.find(
          s => s.id === this.model.weekday_type_id
        ).is_required_study_time
      }

      return true
    }
  },
  methods: {
    checkItem(value) {
      this.model.student_id_list = []
      if (!_.isEmpty(value)) {
        value.forEach(element => {
          this.model.student_id_list.push({
            student_id: element.student_id
          })
        })
      }
    },
    onChangeSubject: function(e) {
      if (e.target.value) {
        this.model.class_name =
          e.target.options[e.target.options.selectedIndex].text
        this.$refs.class_name.focus()
      } else {
        this.model.class_name = ''
      }
    },
    async fetchBeforeCreate() {
      this.loading = true
      await this.$store
        .dispatch('classOperation/dataBeforeCreate')

        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.$store
        .dispatch('classOperation/getStudyTime', {
          ac_st_id: this.model.ac_st_id,
          study_time: this.model.study_time
        })
        .then(response => {
          this.study_times = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      this.loading = false
    },
    async getMainAndSub() {
      let filterSubInterm = this.ac_terms.filter(
        t => t.ac_term_id === this.model.ac_term_id
      )
      if (filterSubInterm.length) {
        this.filterSub = true
        this.model.ac_year_id = filterSubInterm[0].ac_year_id
        this.model.acps_id = filterSubInterm[0].acps_id
        await this.$store
          .dispatch('classOperation/getMainAndSub', filterSubInterm[0].acps_id)
          .then(response => {
            this.subResource = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.filterSub = false
          })
      }
    },
    getLevelBySub(acps_id) {
      this.loading = true
      this.model.level_id = null
      this.$store
        .dispatch('classOperation/getLevel', acps_id)
        .then(response => {
          this.levelResource = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onGetSubject() {
      this.subjectResource = []
      this.model.subject_id = null
      if (
        (this.model.grade_id == null && this.model.academic_year == null) ||
        this.model.academic_term == null
      )
        return
      this.loading = true
      return this.$store
        .dispatch('classOperation/getSubject', {
          grade_id: this.model.grade_id,
          academic_year: this.model.academic_year,
          academic_term: this.model.academic_term
        })
        .then(response => {
          this.subjectResource = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async acYearChange() {
      return this.$store
        .dispatch('classOperation/getTerm', {
          ac_year_id: this.editData.ac_year_id
        })
        .then(response => {
          this.ac_terms = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async findClass() {
      this.loading = true
      await this.$store.dispatch('classOperation/find', this.$route.params.id)
      await this.setEditData()
      this.loading = false
    },
    async setEditData() {
      await this.acYearChange()
      this.model = {
        class_id: this.editData.class_id,
        acp_id: this.editData.acp_id,
        acps_id: this.editData.acps_id,
        level_id: this.editData.level_id,
        ac_year_id: this.editData.ac_year_id,
        ac_term_id: this.editData.ac_term_id,
        academic_year: this.editData.academic_year,
        academic_term: this.editData.academic_term,
        grade_id: this.editData.grade_id,
        room_id: this.editData.room_id,
        teacher_id: this.editData.teacher_id,
        class_name: this.editData.class_name,
        class_desc: this.editData.class_desc,
        building_id: this.editData.room.building_id,
        subject_id: this.editData.room.subject_id,
        ac_st_id: this.editData.ac_st_id,
        weekday_type_id: this.editData.weekday_type_id,
        required_thesis: this.editData.required_thesis
      }
      await this.getMainAndSub()
      await this.onGetSubject()
      this.model.subject_id = this.editData.subject_id
    },
    onSave() {
      this.errors = new Errors()
      this.loading = true
      this.$store
        .dispatch('classOperation/copyClass', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'class-operation' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => this.loading = false)
    }
  },
  watch: {
    'model.acps_id': function(value) {
      if (value) {
        this.getLevelBySub(value)
        this.model.level_id = this.editData.grade.level_id
        this.model.grade_id = this.editData.grade_id
      }
    }
  }
}
</script>
